export function getCourseAccessLevel(user, courseSlug) {
  if (!user) return 0;
  if (user.subscriptionLevel === 9999) return 9999;

  const course = user.courses?.find(
    (course) => 
      course.courseSlug === courseSlug &&
      course.status === "active"
  );

  return Number(course?.level || 0);
}